import { request } from './xcalacocoRequest'

export function fetchXcalacocoBookings(context, params) {
  const cleanParams = {}
  Object.keys(params || {}).forEach(key => {
    const value = params[key]
    if (value !== null && value !== undefined && value !== '') cleanParams[key] = value
  })
  return request({ url: '/xcalacoco/getBookingsAdmin/', method: 'GET', params: cleanParams })
}

export function setXcalacocoBookingStatus(context, body) {
  return request({ url: '/xcalacoco/setBookingStatus/', method: 'PUT', data: body })
}

export function updateXcalacocoBooking(context, body) {
  return request({ url: '/xcalacoco/updateBookingAdmin/', method: 'PUT', data: body })
}

export function fetchXcalacocoBookingById(context, id) {
  return request({ url: '/xcalacoco/getBookingAdmin/', method: 'GET', params: { id } })
}
